import React from "react"
import { withStarRating } from "./withStarRating"

export const StarRating = withStarRating(
  ({ widgetContainer, productId }): JSX.Element => (
    <div style={{ marginBottom: "1.5rem" }} ref={widgetContainer} data-oke-star-rating data-oke-reviews-product-id={`shopify-${productId}`}></div>
  )
)
